<template>
	<div class="pa-3">
		<v-layout>
			<v-spacer></v-spacer>
			<v-menu offset-y :close-on-content-click="false" v-model="toggle.dateMenu" bottom>
				<v-text-field class="validity-input" :value="validity" readonly slot="activator" prepend-icon="event" required></v-text-field>
				<v-card>
					<v-card-text>
						<date-range-picker period="Week" v-model="validityPeriod"></date-range-picker>
						<!-- <v-daterange :no-presets="true" :options="rangePickerOptions" @input="handlePeriodChanged"></v-daterange> -->
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer><v-btn flat @click="toggle.dateMenu = false">Close</v-btn>
					</v-card-actions>
				</v-card>
			</v-menu>
		</v-layout>

		<v-tabs v-model="toggle.selectedTab" color="grey lighten-5" @change="handleTabChanged">
			<v-tab ripple :key="0">Community Actions</v-tab>
			<v-tab ripple :key="1">Contents</v-tab>
			<v-tab ripple :key="2">Members</v-tab>
			<v-tab ripple :key="3">User Reviews</v-tab>

			<v-tab-item :key="1">
				<v-card>
					<v-card-text>
						<table class="stat-table">
							<thead>
								<tr>
									<th rowspan="2">&nbsp;</td>
									<th colspan="3">23-29 January</th>
								</tr>
								<tr>
									<th>Contents</th>
									<th>Loves</th>
									<th>Comments</th>
								</tr>
							</thead>
							<tbody v-if="communityActions">
								<tr>
									<td>TOPIC</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td class="pl-3">HOW TO</td>
									<td>{{ communityActions['TOPIC']['HOWTO']['number_of_contents'] }}</td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td class="pl-3">REVIEW</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td class="pl-3">HAUL</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td class="pl-3">Q&amp;A</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<td class="pl-3">STORY</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</v-card-text>
				</v-card>
			</v-tab-item>

			<v-tab-item :key="2">
				<v-card>
					<v-card-text>
					</v-card-text>
				</v-card>
			</v-tab-item>

			<v-tab-item :key="3">
				<v-card>
					<v-card-text>
					</v-card-text>
				</v-card>
			</v-tab-item>

			<v-tab-item :key="4">
				<v-card>
					<v-card-text>
					</v-card-text>
				</v-card>
			</v-tab-item>
		</v-tabs>

	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import DateRangePicker from '@/components/DateRangePicker.vue'

	export default {
		components: {
			DateRangePicker
		},
		data () {
			return {
				toggle: {
					dateMenu: false,
					selectedTab: 0
				},
				validityPeriod: {
					startDate: null,
					endDate: null
				},
				tabCondition: [],
				communityActions: null
			}
		},
		computed: {
			validity () 
			{
				return (this.validityPeriod.startDate && this.validityPeriod.endDate) ? this.validityPeriod.startDate + ' to ' + this.validityPeriod.endDate : ''
			},
		},
		methods: {
			handleTabChanged (e) 
			{
				var conditionChanged = false

				console.log(this.tabCondition[e])
				console.log(this.validityPeriod)

				if (typeof this.tabCondition[e] === 'undefined') {
					conditionChanged = true
				} else if ((this.tabCondition[e].startDate != this.validityPeriod.startDate) || (this.tabCondition[e].endDate != this.validityPeriod.endDate)) {
					console.log(this.conditionChanged)
					conditionChanged = true
				}
				this.tabCondition[e] = this.validityPeriod

				if (conditionChanged) {
					switch (e) {
						case 0:
							this.refreshCommunityStat()
							break;
						case 1:
							break;
						case 2:
							break;
						case 3:
							break;
					}

					conditionChanged = false
				}
			},
			refreshCommunityStat ()
			{
				var url = `${config.BASE_URL}/stat/community/actionSummary`

				url += '?fr=' + this.validityPeriod.startDate
				url += '&to=' + this.validityPeriod.endDate

				axios.get(url)
					.then(response => {
						console.log(response.data.data)
						this.communityActions = response.data.data
					})
			}
		},
		mounted () {

		}
	}
</script>

<style lang="scss">
	.validity-input {
		width: 290px;
	}

	table.stat-table {
		width: 100%;

		thead {
			tr {
				th {
					text-align: center;
				}
			}
		}
	}
</style>